import React from 'react';
import { Icon } from './Icon.js';
export const IconChartPie5 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 10C2 5.58172 5.58169 2 10 2V10H2Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M4 13C4 17.9706 8.02944 22 13 22C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4", stroke: "currentColor", strokeWidth: "2", strokeLinejoin: "round", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChartPie5.js.map